window.StockCubeCore = window.StockCubeCore || {};

window.StockCubeCore.tick = function (time, timeDelta) {
    if (!this.emissivePulse || !this.emissivePulse.bars || this.emissivePulse.bars.size === 0) return;

    this._emissiveTickAccumulator = (this._emissiveTickAccumulator || 0) + (timeDelta || 0);
    if (this._emissiveTickAccumulator < 33) return;
    this._emissiveTickAccumulator = 0;

    const period = this.emissivePulse.periodMs || 3000;
    const t = ((time - (this.emissivePulse.epochMs || 0)) % period + period) % period;
    const phase = t / period;
    const wave = 0.5 * (1 - Math.cos(Math.PI * 2 * phase));

    this.emissivePulse.bars.forEach((info) => {
        const { el, min, max } = info;
        if (!el) return;
        const intensity = min + (max - min) * wave;
        const mesh = el.getObject3D('mesh');
        if (mesh && mesh.material) {
            const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
            materials.forEach((material) => {
                if (material && 'emissiveIntensity' in material) {
                    material.emissiveIntensity = intensity;
                }
            });
        } else {
            el.setAttribute('material', 'emissiveIntensity', intensity);
        }

        if (info.labelEl) {
            const s = 1.0 + 0.15 * wave;
            info.labelEl.setAttribute('scale', `${s} ${s} ${s}`);
        }
    });
};
